export default "__VITE_ASSET__CsoCPuWY__"